module.exports = __webpack_public_path__ + "media/images/konintodoke/other_services/logo03-39f7767ec56516d338ab86f025061f57.png";